/**
 * Production-safe logger. Suppresses output in production builds
 * so internal logic and stack traces don't leak in the browser console.
 */
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  log: (...args) => { if (!isProd) console.log(...args); },
  warn: (...args) => { if (!isProd) console.warn(...args); },
  error: (...args) => { if (!isProd) console.error(...args); }
};
